import { render, staticRenderFns } from "./OrganizationMailTemplates.vue?vue&type=template&id=1107cf5f&scoped=true&"
import script from "./OrganizationMailTemplates.vue?vue&type=script&lang=js&"
export * from "./OrganizationMailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMailTemplates.vue?vue&type=style&index=0&id=1107cf5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107cf5f",
  null
  
)

export default component.exports